import { ROUTES as CONFIGURE_ROUTES } from 'views/Configure/stubs';
import SETTNGS_ROUTE from 'views/Settings/stubs/routes';
import { NOTIFICATION_ACTION_IDS } from '../stubs';

export const doActionTemplateId = (actionId, { redirectFn = () => {} }) => {
  switch (actionId) {
    case NOTIFICATION_ACTION_IDS['rr-low-balance']:
    case NOTIFICATION_ACTION_IDS['rr-no-balance']: {
      redirectFn(SETTNGS_ROUTE.MANAGE_SUBSCRIPTION);
      break;
    }
    case NOTIFICATION_ACTION_IDS['no-default-warehouse']: {
      redirectFn(CONFIGURE_ROUTES.RETURN_LOCATIONS);
      break;
    }
    case NOTIFICATION_ACTION_IDS['no-aggregator-setup']:
    case NOTIFICATION_ACTION_IDS.aggregators: {
      redirectFn(CONFIGURE_ROUTES.AGGREGATORS);
      break;
    }
    case NOTIFICATION_ACTION_IDS['refund-processing-fee']: {
      redirectFn(
        `${CONFIGURE_ROUTES.REFUND_METHODS}/original-payment-method#fee`
      );
      break;
    }
    case NOTIFICATION_ACTION_IDS['purchases']: {
      redirectFn(CONFIGURE_ROUTES.PURCHASES);
      break;
    }
    case NOTIFICATION_ACTION_IDS['tag-based-rules']: {
      redirectFn(CONFIGURE_ROUTES.TAG_BASED_RETURN_RULES);
      break;
    }
    default:
      break;
  }

  return null;
};
